import { Element } from 'slate';
import { BlockElement } from '../../types';

export const quizType = 'quiz';

export const isQuizElement = (
  element: Omit<Element, 'children'>,
): element is BlockElement => element.type === quizType;
